import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-8 display-4 text-center font-weight-bold"
}
const _hoisted_2 = {
  key: 1,
  class: "mt-2 display-4 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, { class: "mx-auto" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "12",
          class: "mx-auto text-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_avatar, {
              size: "256",
              class: "text-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_img, {
                  rounded: true,
                  contain: "",
                  height: "480",
                  class: "rounded-xl",
                  src: "/img/mario-profile.jpg"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "12",
          class: "text-center"
        }, {
          default: _withCtx(() => [
            true
              ? (_openBlock(), _createElementBlock("h1", _hoisted_1, " Mario Novak "))
              : _createCommentVNode("", true),
            true
              ? (_openBlock(), _createElementBlock("h2", _hoisted_2, " Software Architect "))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}